/*
    表格区展开侧拉区域组件
    created by: liyaoh 2019-05-31
*/
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { Drawer } from 'antd';
import platform from "Pub/js/platform";
import { connect } from "react-redux";
import { processClass } from '../LeftSideMetaTree/util';
import { LEFT_SIDER_WIDTH } from '../../events';
const { NCDiv } = platform.base;

const areaTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        //从左侧拖拽非元数据
        if (dragItem.type === 'card') {
            props.onDrop(monitor);
        }
    }
};

//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', areaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
}))
class TableDrawerArea extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            areaClassName,
            side,
            children,
            isActive,
            renderCard,
            visible,
            renderHeader,
            onClick,
            connectDropTarget
        } = this.props;
        let queryList = side.queryPropertyList;
        let listWithBlank = [
            ...queryList,
            { blank: true, areaid: side.pk_area, code: 'blank', renderType: 'tableSide' }
        ]
        let processedSideCode = processClass(side.code) || 'unknow';
        return <Drawer
            getContainer={document.getElementsByClassName("template-setting-content")[0]}
            closable={false}
            placement="right"
            maskClosable={false}
            width={725}
            visible={visible}
            mask={true}
            zIndex={180}
            destroyOnClose={true}
            style={{ padding: 0, height: '100%' }}
            maskStyle={{ left: this.props.leftSiderShow ? LEFT_SIDER_WIDTH + 16 : 16 }}
        >
            {
                <div className="drawer-content">
                    <div 
                        className={`${areaClassName} side-area search-area-${String(side.code).replace(/\.|\&|\#/g, '') || 'unknow'}`} 
                        style={{ position: 'static' }} 
                        onClick={onClick}
                    >
                        <NCDiv className="table-side-area" fieldid="table-side" areaCode={NCDiv.config.Area}>
                            {renderHeader}
                            {connectDropTarget(
                                <div className={`area-item-content drag-mask-${processedSideCode}`} fieldid="content">
                                    <div className={`form-area-group ${isActive ? 'active' : ''}`}>
                                        <div className="form-area-content">
                                            {listWithBlank.map(renderCard)}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </NCDiv>
                    </div>
                    {/* 孙表区域 */}
                    {
                        children && children()
                    }
                </div>
            }
        </Drawer>
    }
}

export default connect(
    state => ({
        leftSiderShow: state.zoneSettingData.leftSiderShow
    }),
    {}
)(TableDrawerArea);
